export default __webpack_public_path__ + "static/media/doge-game-revised.1ed5802d.jpg";